import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationQuestionAnswer } from 'projects/qcloud-models/reservation/reservation-question-answer';
import { ReservationQuestionType } from 'projects/qcloud-models/reservation/reservation-question-type.enum';
import { ReservationQuestion } from 'projects/qcloud-models/reservation/reservation-questions';
import { TicketReservationService } from '../../../services/ticket-reservation.service';

@Component({
  selector: 'app-reservation-questionaire',
  templateUrl: './reservation-questionaire.component.html',
  styleUrls: ['./reservation-questionaire.component.scss']
})
export class ReservationQuestionaireComponent implements OnInit {

  @Input() questions: ReservationQuestion[];
  ticketReservation = new TicketReservationPlugin();
  reservationQuestions: ReservationQuestionAnswer[] = [];
  ReservationQuestionType = ReservationQuestionType;
  @Output() formInvalid = new EventEmitter();
  containsLinkRegex = new RegExp("([a-zA-Z\d]+[.][A-Za-z]{2,4})");
  textInvalid = false;
  FIRST_OPTION = '1';
  SECOND_OPTION = '2';

  constructor(private ticketReservationService: TicketReservationService, private translate: TranslateService) {
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => {
      this.ticketReservation = val;
    });

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      let locale = event.lang;
      this.reservationQuestions.forEach(question => {
        let parentQuestion = this.questions.find(x => x.id == question.questionId);
        question.question = parentQuestion.translations.find(x => x.locale.slice(0, 2) == locale)?.translation ??
          parentQuestion.question;
      });
    });
  }

  ngOnInit(): void {
    this.reservationQuestions = this.questions.map(question =>
      new ReservationQuestionAnswer(question, this.translate.currentLang));
    if (this.questions.length === 0) {
      this.formInvalid.emit(false);
    } else {
      this.formInvalid.emit(true);
    }

    this.reservationQuestions.forEach(answer => {
      if (answer.questionType == ReservationQuestionType.Option ||
        answer.questionType == ReservationQuestionType.VisibleOption) {
        if (!answer.answer) {
          answer.answer = this.FIRST_OPTION;
        }
      }
    });
  }

  updateTicketReservation(formInvalid: boolean) {
    this.ticketReservation.additionalReservationData = this.reservationQuestions;
    this.ticketReservationService.updateTicketReservation(this.ticketReservation);
    this.formInvalid.emit(formInvalid || this.textInvalid);
  }

  checkVisible(reservationQuestion: ReservationQuestionAnswer): boolean {
    return (reservationQuestion.visible ||
      this.reservationQuestions.find(x => x.questionType == ReservationQuestionType.VisibleOption).answer == '2') &&
      this.checkVisibleInCategory(reservationQuestion);
  }

  checkVisibleInCategory(reservationQuestion: ReservationQuestionAnswer): boolean {
    return !reservationQuestion.hiddenCategories.some(x => x.id == this.ticketReservation.categoryId);
  }

  checkForUrls(answer: string) {
    if (this.containsLinkRegex.test(answer)) {
      this.textInvalid = true;
      this.updateTicketReservation(true);
    }
    else {
      this.textInvalid = false;
    }
  }
}
